var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigRule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.314,
    height: 65.044,
    viewBox: "0 0 53.314 65.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#00a4e3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1393 -243.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.391,7.5H38.01A9.016,9.016,0,0,0,29.657,1,9.016,9.016,0,0,0,21.3,7.5H8.924C5.666,7.5,3,10.431,3,14.009V59.539c0,3.577,2.666,6.5,5.924,6.5H50.391c3.258,0,5.924-2.927,5.924-6.5V14.009C56.314,10.431,53.649,7.5,50.391,7.5Zm-20.733,0a3.126,3.126,0,0,1,2.962,3.252,3.126,3.126,0,0,1-2.962,3.252A3.126,3.126,0,0,1,26.7,10.757,3.126,3.126,0,0,1,29.657,7.5Z",
    transform: "translate(1390 242.997)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1403.1 267.227)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26.134,
    height: 5.807,
    rx: 2.904,
    transform: "translate(8.711)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26.134,
    height: 5.807,
    rx: 2.904,
    transform: "translate(8.711 11.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 26.134,
    height: 5.807,
    rx: 2.904,
    transform: "translate(8.711 23.23)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.807,
    height: 5.807,
    rx: 2.904
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.807,
    height: 5.807,
    rx: 2.904,
    transform: "translate(0 11.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.807,
    height: 5.807,
    rx: 2.904,
    transform: "translate(0 23.23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigRule);
export default __webpack_public_path__ + "static/media/configRule.b9b2a8a8d0a97bc2246ade937af3a4eb.svg";
export { ForwardRef as ReactComponent };